import { useCreditNoteDetailTracked } from "presentation/store/CreditNote/CreditNoteDetailProvider";
import { memo, useMemo } from "react";
import { GetRecordsByInvoiceNoTablePanel } from "./GetRecordsByInvoiceNoTablePanel";
import GetRecordsByInvoiceNoTitleBar from "./GetRecordsByInvoiceNoTitleBar";
import { TariffItemsByInvoiceTablePanel } from "./TariffItemsByInvoiceTablePanel";

const InvoiceRecordsRightPanel = () => {
    const [creditNoteDetailState] = useCreditNoteDetailTracked();
    const { isShowTariffItemPanel } = creditNoteDetailState.creditNoteDetailState;

    const memoTariffItemPanel = useMemo(() => {
        return isShowTariffItemPanel && <TariffItemsByInvoiceTablePanel />;
    }, [isShowTariffItemPanel])
    const memoRecordsByInvoicePanel = useMemo(() => {
        return <GetRecordsByInvoiceNoTablePanel />;
    }, [])

    return <>
        <div className={`main-comp-wrapper`}>
            <div style={{ height: '8%' }}>
                <GetRecordsByInvoiceNoTitleBar />
            </div>
            <div style={{ height: '40%' }}>
                {memoRecordsByInvoicePanel}
            </div>

            {<div style={{ height: '52%' }}>
                {memoTariffItemPanel}
            </div>}
        </div>
    </>
}

export default memo(InvoiceRecordsRightPanel);